import { extendTheme } from "@chakra-ui/react";

const colors = {
  ambra: "rgba(255, 191, 0, 0.5)",
  ambraHover: "rgba(255,191,0, 0.8)",
};

const fonts = {
  titolo: "2rem",
  titolino: "1.23rem",
  testo: "0.763rem",
};

const theme = extendTheme({
  fonts,
  colors,
  components: {
    Tabs: {
      color: "rgba(0, 0, 0, 0.9)",
      baseStyle: {
        tab: {
          _selected: {
            color: "rgba(0, 0, 0, 0.9)", // Set the color you want for the active tab
          },
        },
      },
    },
  },
});

export default theme;
